"use strict";
/**
 * Created on 05 26 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link ProductSensitivityExportQueueRecord}.
 *
 * @author JMe
 */


var ProductSensitivityExportQueueRecordConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductSensitivityExportQueueRecordConverter, _DataObjectConverter_);

  function ProductSensitivityExportQueueRecordConverter() {
    _classCallCheck(this, ProductSensitivityExportQueueRecordConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSensitivityExportQueueRecordConverter).apply(this, arguments));
  }

  return ProductSensitivityExportQueueRecordConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductSensitivityExportQueueRecordConverter = ProductSensitivityExportQueueRecordConverter;